// generic-client
import { es, pt } from 'date-fns/locale';

export const VALID_LANGUAGES = ['es', 'en', 'pt'];
export const DEFAULT_LANGUAGE = 'en';
export const LANG_LOCALES = {
  en: 'en-US',
  es: 'es-LA',
  pt: 'pt-BR',
};

export function getBaseURL() {
  return window.location.origin.replace('app.', '');
}

export function getTosLink(language) {
  const lang = VALID_LANGUAGES.includes(language) ? `/${language}` : '';
  return `https://www.airtm.com${lang}/terms-and-conditions`;
}

export const localeES = es;
localeES.code = LANG_LOCALES.es;

export const localePT = pt;
localePT.code = LANG_LOCALES.pt;

export const LOCALES = {
  es: localeES,
  pt: localePT,
};

export const STATUS = {
  ACCEPTED: 'ACCEPTED',
  CANCEL_REQUESTED: 'CANCEL_REQUESTED',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  CONFIRMED: 'CONFIRMED',
  CREATED: 'CREATED',
  ERROR: 'ERROR',
  FAILED: 'FAILED',
  MEDIATION: 'MEDIATION',
  MEDIATION_SETTLED_MAKER: 'MEDIATION_SETTLED_MAKER',
  MEDIATION_SETTLED_TAKER: 'MEDIATION_SETTLED_TAKER',
  MEDIATION_SETTLED_BUYER: 'MEDIATION_SETTLED_BUYER',
  MEDIATION_SETTLED_SELLER: 'MEDIATION_SETTLED_SELLER',
  PENDING: 'PENDING',
  UPDATE_PENDING: 'UPDATE_PENDING',
  FRAUD_REJECTED: 'FRAUD_REJECTED',
  FRAUD_REVIEW: 'FRAUD_REVIEW',
  FRAUD_APPROVED: 'FRAUD_APPROVED',
  MATCHED: 'MATCHED',
  MERGED: 'MERGED',
};

export const PAYOUT_STATUSES = {
  CANCELED: STATUS.CANCELED,
  COMPLETED: STATUS.COMPLETED,
  CREATED: STATUS.CREATED,
  FAILED: STATUS.FAILED,
  PENDING: STATUS.PENDING,
  CANCEL_REQUESTED: STATUS.CANCEL_REQUESTED,
  BRIDGE_USER_SIGNUP_PENDING: 'BRIDGE_USER_SIGNUP_PENDING',
  STELLAR_USER_SIGNUP_PENDING: 'STELLAR_USER_SIGNUP_PENDING',
};

export const PENDING_STATUSES = [
  PAYOUT_STATUSES.PENDING,
  PAYOUT_STATUSES.BRIDGE_USER_SIGNUP_PENDING,
  PAYOUT_STATUSES.STELLAR_USER_SIGNUP_PENDING,
];

export const FINAL_STATUSES = [STATUS.COMPLETED, STATUS.CANCELED, STATUS.FAILED, STATUS.CONFIRMED];

export const BULK_PAYOUT_STATUSES = {
  COMPLETED: STATUS.COMPLETED,
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING: STATUS.PENDING,
  REJECTED: 'REJECTED',
  UNCOMPLETED: 'UNCOMPLETED',
};

export const LOCAL_STORAGE = {
  JWT: 'AirtmJWT',
  JWT_IDLE_EXPIRES_AT: 'airtm-jwt-idle-expires-at',
  STORED_NS: 'stored',
  LANGUAGE: 'AirtmLng',
  KOUNT_SESSIONID: 'KountSessionid',
  UTM: 'AirtmUTM',
  SKIP_LOGIN_REDIRECTION: 'AirtmSkipLoginRedirection',
  REQUEST_VERIFICATION_EMAIL: 'AirtmVerifyEmailSent',
  SHOW_DOCUMENTATION_SCREEN: 'AirtmShowDocumentationScreen',
  SKIP_SELECT_PROVIDER: 'AirtmSkipSelectProvider',
  SHOW_ENABLE_2FA_SCREEN: 'AirtmShowEnable2FAScreen',
  SELECTED_CUSTODIAL_PROVIDER: 'AirtmSelectedCustodialProvider',
  SKIP_COOKIE_BANNER: 'AirtmSkipCookieBanner',
};

export const LOCAL_STORAGE_WHITELIST = [
  LOCAL_STORAGE.SKIP_SELECT_PROVIDER,
  LOCAL_STORAGE.SHOW_ENABLE_2FA_SCREEN,
  LOCAL_STORAGE.SKIP_LOGIN_REDIRECTION,
  LOCAL_STORAGE.KOUNT_SESSIONID,
  LOCAL_STORAGE.SHOW_DOCUMENTATION_SCREEN,
  LOCAL_STORAGE.SELECTED_CUSTODIAL_PROVIDER,
  `${LOCAL_STORAGE.STORED_NS}.${LOCAL_STORAGE.SKIP_COOKIE_BANNER}`,
  '__leanplum_device_id',
  '__leanplum_user_id',
  '__leanplum_session',
  '__leanplum_message_cache',
  '__leanplum_variables',
  '__leanplum_variants',
  '__leanplum_action_metadata',
  '__leanplum_variant_debug_info',
  '__leanplum_token',
];

export const PAGINATION_PER_PAGE = 25;

export const SUPPORT_EMAIL = 'support@airtm.com';

export const OTP_CODE_LENGTH = 6;

export const CURRENCY = {
  USD: {
    id: 'USD',
    precision: 2,
    symbol: '$',
  },
  USDC: {
    id: 'USDC',
    precision: 2,
    symbol: '$',
  },
  USDT: {
    id: 'USDT',
    precision: 2,
    symbol: '$',
  },
  EUR: {
    id: 'EUR',
    precision: 2,
    symbol: '€',
  },
};

export const CUSTODIAL_PROVIDERS = {
  BRIDGE: 'BRIDGE',
};

export const ALL_PAYOUTS_PATH = 'payouts';
export const BULK_PAYOUTS_PATH = 'bulk-payouts';
export const BRIDGE_FUNDINGS_TYPES = {
  FUNDING: 'funding',
  REFUNDED: 'refunded',
  TRANSFER: 'transfer',
};
